import { http } from '../../../../api/axios';
import { libraryManagedConfig } from '../../../../config';
import { FeaturedPageOut } from '../../../../store/api';

export const fetchLibraryManagedProductGroupsFeaturedPages = () => {
    return http
        .get<FeaturedPageOut[]>(libraryManagedConfig().endpointProductGroupFeaturedPages)
        .then(response => response.data);
};
